@import (reference) '../../../../constants/spacing.module.less';

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.content {
  flex: 1;
  overflow-y: auto;
  padding-left: @space-16;
  padding-right: @space-16;
  width: 100%;
  max-width: 100%;
  background-color: var(--gray-F9FAFB);
}
